var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMarker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 43.193,
    height: 55.205,
    viewBox: "0 0 43.193 55.205",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,3C16.71,3,7.5,11.263,7.5,21.479,7.5,35.337,28.1,55.8,28.1,55.8s20.6-20.458,20.6-34.317C48.693,11.263,39.484,3,28.1,3Zm0,25.078c-4.06,0-7.356-2.957-7.356-6.6s3.3-6.6,7.356-6.6,7.356,2.957,7.356,6.6S32.157,28.078,28.1,28.078Z",
    transform: "translate(-6.5 -2)",
    fill: "none",
    stroke: "#3d5567",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marker.1b92bd6c.svg";
export { ForwardRef as ReactComponent };